import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { GridComponent, ColumnsDirective, ColumnDirective, Inject, Sort, Page, Toolbar, Resize, PageSettingsModel } from '@syncfusion/ej2-react-grids';

import { IReportChangesHistoryTabProps } from '../../../../interfaces/props/IReportDetailProps';
import { IReportChangeHistory } from '../../../../common/model/reportChangeHistory.model';
import * as pagerUtils from '../../../../utils/pager.utils';
import * as reportChangeHistoryUtils from '../../../../utils/reportChangeHistoryType.utils';
import * as dateHelpers from '../../../../helpers/date.helpers';
import './reportChangesHistoryTab.scss';

type ReportChangesHistoryTabPropsType = IReportChangesHistoryTabProps & WithTranslation;

class ReportChangesHistoryTab extends Component<ReportChangesHistoryTabPropsType> {
  public pageSettings: PageSettingsModel = {
    pageSize: pagerUtils.getMaxPageSize(),
    pageCount: pagerUtils.getPageCount(),
    pageSizes: pagerUtils.getPageSizes()
  };

  public constructor(props: ReportChangesHistoryTabPropsType) {
    super(props);
  }

  public getCreatedDateLabel(reportChangeHistory: IReportChangeHistory): string {
    return `${dateHelpers.toShortDate(reportChangeHistory.createdDate, true)} ${dateHelpers.toDateWithoutZones(reportChangeHistory.createdDate, 'HH:mm:ss')}`;
  }

  public getUserColumnLabel(reportChangeHistory: IReportChangeHistory): string {
    return `${reportChangeHistory.userFirstName} ${reportChangeHistory.userLastName}`;
  }

  public getTypeColumnLabel(reportChangeHistory: IReportChangeHistory): string {
    return reportChangeHistoryUtils.getLocalizedTextByValue(this.props.i18n, reportChangeHistory.type);
  }

  public render() {
    const { reportChangesHistory, i18n } = this.props;

    return (
      <div className='report-changes-history-grid'>
        <GridComponent
          dataSource={reportChangesHistory}
          allowSorting={true}
          allowPaging={true}
          allowResizing={true}
          pageSettings={this.pageSettings}
          clipMode='EllipsisWithTooltip'
          locale={i18n.language}
        >
          <ColumnsDirective>
            <ColumnDirective
              headerText={this.props.i18n.t('reportChangeHistory.createdDate')}
              field='createdDate'
              width='100'
              valueAccessor={(_field, data) => this.getCreatedDateLabel(data as IReportChangeHistory)}
            />
            <ColumnDirective
              headerText={i18n.t('reportChangeHistory.user')}
              field='userFirstName'
              width='100'
              valueAccessor={(_field, data) => this.getUserColumnLabel(data as IReportChangeHistory)}
            />
            <ColumnDirective
              headerText={i18n.t('reportChangeHistory.type')}
              field='type'
              width='100'
              valueAccessor={(_field, data) => this.getTypeColumnLabel(data as IReportChangeHistory)}
            />
            <ColumnDirective
              headerText={this.props.i18n.t('reportChangeHistory.detail')}
              field='detail'
              width='250'
            />
          </ColumnsDirective>
          <Inject services={[Sort, Page, Toolbar, Resize]} />
        </GridComponent>
      </div>
    );
  }
}

export default withTranslation()(ReportChangesHistoryTab);
